export const RESET_STATE = 'RESET_STATE';
export const RESET_NOT_PERSISTED = 'RESET_NOT_PERSISTED';
